import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  spreadSheet: {
    marginTop: 24
  },
  spreadSheetTable: {
    '& .Spreadsheet__cell, & .Spreadsheet__header': {
      // stretch the column to the full width of the table
      '&:nth-child(2)': {
        width: '50%'
      },
      '&:nth-child(3)': {
        width: '50%'
      }
    }
  }
})

export default useStyles
